let widgetId = null;
let submittingFromCaptcha = false;
let tokenResolvers = [];

document.addEventListener("hcaptcha:ready", bindHcaptcha);
document.addEventListener("turbo:load", bindHcaptcha);
document.addEventListener("turbo:render", (e) => {
  if (document.documentElement.hasAttribute("data-turbo-preview")) return;
  bindHcaptcha();
});

document.addEventListener("turbo:before-cache", () => {
  const hcaptchaContainerEl = document.getElementById("hcaptcha-container");
  if (hcaptchaContainerEl) {
    hcaptchaContainerEl.innerHTML = "";
  }
  if (window.hcaptcha && widgetId !== null) {
    try { hcaptcha.remove(widgetId); } catch (error) { Bugsnag.notify(error) }
  }
  widgetId = null;
});

function deliverToken(token) {
  try { window.__hcaptcha_token = token || ((widgetId != null) ? hcaptcha.getResponse(widgetId) : ""); }
  catch (_) { window.__hcaptcha_token = ""; }

  const resolvers = tokenResolvers.splice(0);
  for (let i = 0; i < resolvers.length; i++) {
    try { resolvers[i](window.__hcaptcha_token); } catch (error) { Bugsnag.notify(error) }
  }
}

function createHcaptchaCallback(form) {
  return (token) => {
    submittingFromCaptcha = true;
    deliverToken(token);
    setTimeout(() => {
      if (form && form.requestSubmit) { form.requestSubmit(); }
      else if (form) { form.submit(); }
      submittingFromCaptcha = false;
    }, 0);
  };
}

function renderWidget(hcaptchaContainerEl, form) {
  widgetId = hcaptcha.render(hcaptchaContainerEl, {
    sitekey: hcaptchaContainerEl.dataset.sitekey,
    size: hcaptchaContainerEl.dataset.size,
    callback: createHcaptchaCallback(form)
  });
}

function tryExecuteHcaptcha() {
  if (widgetId != null) {
    try {
      hcaptcha.execute(widgetId);
    } catch (error) { Bugsnag.notify(error) }
  }
}

function executeOrScroll(hcaptchaContainerEl) {
  if (hcaptchaContainerEl.dataset.size === "invisible" && widgetId != null) {
    try { hcaptcha.execute(widgetId); } catch (error) { Bugsnag.notify(error) }
  } else {
    try { hcaptchaContainerEl.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (error) { Bugsnag.notify(error) }
  }
}

function bindHcaptcha() {
  if (!window.hcaptcha) return;

  const hcaptchaContainerEl = document.getElementById("hcaptcha-container");
  if (!hcaptchaContainerEl) {
    return;
  }

  const form = hcaptchaContainerEl.closest("form");

  if (!hcaptchaContainerEl.querySelector('iframe[src*="hcaptcha.com"]')) {
    renderWidget(hcaptchaContainerEl, form);

    if (form) {
      form.addEventListener("submit", (e) => {
        if (submittingFromCaptcha) return;
        let token = "";
        try { token = widgetId != null ? hcaptcha.getResponse(widgetId) : ""; }
        catch (_) {
          e.preventDefault();
          try { if (widgetId != null) hcaptcha.remove(widgetId); } catch (error) { Bugsnag.notify(error) }
          hcaptchaContainerEl.innerHTML = "";
          renderWidget(hcaptchaContainerEl, form);
          executeOrScroll(hcaptchaContainerEl);
          return;
        }
        if (!token) {
          e.preventDefault();
          executeOrScroll(hcaptchaContainerEl);
        }
      });
    }
  }
}

window.requestHcaptchaToken = function requestHcaptchaToken() {
  return new Promise((resolve) => {
    if (!window.hcaptcha) { resolve(); return; }
    if (window.__hcaptcha_token) { resolve(window.__hcaptcha_token); return; }
    tokenResolvers.push(resolve);
    try {
      if (widgetId != null) {
        hcaptcha.execute(widgetId);
      } else {
        bindHcaptcha();
        requestAnimationFrame(tryExecuteHcaptcha);
      }
    } catch (_) { resolve(); }
  });
}
